import { instance as axios, setJwtToken } from "../../config/axiosInstance";

//Get Support Ticket list
export const getSupportListApi = async (data) => {
  const endPoint = `admin-support/support-list?${new URLSearchParams({
    ...data,
  }).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// Selected Ticket Reply
export const selectedTicketReplyApi = async (data) => {
  const endPoint = `admin-support/reply-support`;
  return await axios.put(endPoint, data, setJwtToken());
};

